import { useQuery } from 'react-query';
import {
  getMyBettieAutoTopUp,
  type GetMyBettieAutoTopUpResponse
} from '../../services/bettieAutoTopUpService';

export function useGetMyBettieAutoTopUp(options?: { enabled?: boolean }) {
  return useQuery<GetMyBettieAutoTopUpResponse | undefined, Error>(
    ['bettieAutoTopUp'],
    () => getMyBettieAutoTopUp(),
    { enabled: options?.enabled ?? true }
  );
}
